import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../step-progress-bar.scss';
import '../step/step.scss';

interface StepProgressBarSkeletonProps extends React.ComponentPropsWithoutRef<'div'> {
    stepCount?: number;
}

export const StepProgressBarSkeleton = ({ stepCount = 3, ...props }: StepProgressBarSkeletonProps) => {
    return (
        <div {...props}>
            <ol className="step-progress-bar step-progress-bar--skeleton">
                {Array.from({ length: stepCount }, (_, index) => (
                    <li key={index} className="step-progress-bar__list-element">
                        <LineBefore />
                        <Skeleton circle height={56} width={56} />
                        <LineAfter />
                        <Label />
                    </li>
                ))}
            </ol>
        </div>
    );
};

const LineBefore = () => (
    <span className="step-progress-bar__list-element__line--before">
        <Skeleton height={2} />
    </span>
);

const LineAfter = () => (
    <span className="step-progress-bar__list-element__line--after">
        <Skeleton height={2} />
    </span>
);

const Label = () => (
    <span className="step-progress-bar__step__label">
        <Skeleton height={24} width={80} />
    </span>
);
